import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Sends a GA4 page_view on every client-side route change (initial load is handled by gtag('config')).
export const Analytics = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, search]);
  return null;
};

export default Analytics;
